"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearInputValue = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const react_arb_tools_1 = require("@amzn/react-arb-tools");
const awsui_components_react_1 = require("@amzn/awsui-components-react");
const CONSTANTS = __importStar(require("../../../common/constants"));
const apis_1 = require("../../../service/apis");
const base_layout_1 = require("../../common/base_layout");
const bread_crumbs_1 = require("../../common/bread_crumbs");
const notification_1 = require("../../common/notification");
const provision_input_form_1 = __importDefault(require("./provision_input_form"));
const registered_information_1 = require("./registered_information");
const hooks_1 = require("../../../common/hooks");
const functions_1 = require("../../../common/functions");
const process_helpers_1 = require("../../../common/process_helpers");
const node_id_input_cell_1 = require("../../common/client_inputs/node_id_input_cell");
const constants_1 = require("../../../common/constants");
function clearInputValue() {
    Array.from(document.querySelectorAll('input')).forEach((input) => (input.value = ''));
}
exports.clearInputValue = clearInputValue;
const Content = (props) => {
    const [isSubmit, setIsSubmit] = react_1.default.useState(false);
    const [submitSucceed, setSubmitSucceed] = react_1.default.useState(false);
    const [refreshData, setRefreshData] = react_1.default.useState(false);
    const [formErrors, setFormErrors] = react_1.default.useState({});
    const [localeBundle] = (0, react_arb_tools_1.useBundle)(CONSTANTS.STRINGS_NAMESPACE);
    const process = (0, process_helpers_1.useProcess)();
    const [localeBundleLoaded, setLocaleBundleLoaded] = react_1.default.useState(false);
    const [templateUrls, setTemplateUrls] = react_1.default.useState({});
    const [provisionInputTemplate, setProvisionInputTemplate] = (0, react_1.useState)([]);
    const [selectedPodId, setSelectedPodId] = (0, react_1.useState)(null);
    const initialProvisioningInputs = {};
    const initialFormData = {
        authDeviceCode: props.deviceCode,
        nodeId: props.isManagedEdgeCompute ? undefined : props.nodeId,
        podId: undefined,
        workcellNumber: undefined,
        provisioningInputs: initialProvisioningInputs,
    };
    const [formData, setFormData] = react_1.default.useState(initialFormData);
    const onRefreshClick = () => {
        setRefreshData(!refreshData);
        clearInputValue();
        setSelectedPodId(null);
        setProvisionInputTemplate([]);
        setFormData(initialFormData);
        props.setNotificationToPage([]);
        setFormErrors({});
        setSubmitSucceed(false);
    };
    const validateInput = (form, inputTemplate) => {
        const errors = {};
        const validateInputTemplate = Object.create(inputTemplate);
        if (props.isManagedEdgeCompute) {
            validateInputTemplate.push(node_id_input_cell_1.node_id_input_cell);
        }
        validateInputTemplate.map((element) => {
            const fieldName = element.name;
            const fieldLabel = element.label;
            let regex;
            let value;
            if (element.component === 'field') {
                value = form[fieldName];
            }
            else {
                value = form.provisioningInputs[fieldName];
            }
            if (!value && element.component !== 'provision-input-group-optional') {
                errors[fieldLabel] = localeBundle.formatMessage('provision-input-field-is-required', {
                    field: fieldLabel,
                });
            }
            else if ((value === null || value === undefined) &&
                element.component === 'provision-input-group-optional') {
                // skip validation for optional inputs.
                // value could be null or undefined which will later be ignored when talking to lambda
                // logic will be updated later consolidating provision-input-group and provision-input-group-optional
                console.log('Skipping null check for optional inputs');
            }
            else {
                regex = element.regex;
                const regExp = new RegExp(regex);
                if (!regExp.test(value)) {
                    errors[fieldLabel] = localeBundle.formatMessage('provision-input-field-must-follow-pattern', {
                        field: fieldLabel,
                        pattern: regex,
                    });
                }
            }
        });
        return errors;
    };
    function onSubmitClick(e) {
        e.preventDefault();
        setFormErrors(validateInput(formData, provisionInputTemplate));
        setIsSubmit(true);
    }
    react_1.default.useEffect(() => {
        if (localeBundle !== undefined) {
            setLocaleBundleLoaded(true);
        }
    });
    react_1.default.useEffect(() => {
        if (localeBundleLoaded) {
            clearInputValue();
            setSelectedPodId(null);
            setTemplateUrls({});
            setProvisionInputTemplate([]);
            setFormData(initialFormData);
            props.setNotificationToPage([]);
            (0, apis_1.getApis)()
                .getProvisionInputTemplateUrls({ processId: process.selectedProcess })
                .then((response) => {
                setTemplateUrls(response.templateUrls);
            })
                .catch((error) => {
                let errorContent;
                if (error.response) {
                    errorContent = localeBundle.formatMessage('get-provision-input-template-failure', {
                        errorMessage: error.response.data.message,
                    });
                }
                else {
                    errorContent = localeBundle.formatMessage('get-provision-input-template-failure', {
                        errorMessage: error.message,
                    });
                }
                console.log(error);
                props.setNotificationToPage([
                    {
                        header: localeBundle.getMessage('something-wrong'),
                        type: 'error',
                        content: `${errorContent}`,
                        dismissible: true,
                        dismissLabel: 'Dismiss message',
                        onDismiss: () => props.setNotificationToPage([]),
                    },
                ]);
            });
        }
    }, [process.selectedProcess, localeBundleLoaded]);
    react_1.default.useEffect(() => {
        if (isSubmit && localeBundleLoaded) {
            setIsSubmit(false);
            if ((0, functions_1.sizeOfObject)(formErrors) === 0) {
                const deviceId = `${formData.nodeId}-${props.processId}-${formData.workcellNumber}`;
                (0, apis_1.getApis)()
                    .transactionalSaveProvisionDetails({
                    saveProvisionDetailsInput: {
                        authDeviceCode: formData.authDeviceCode,
                        deviceId: deviceId,
                        deviceName: deviceId,
                        nodeId: formData.nodeId,
                        processId: props.processId,
                        provisioningInputs: formData.provisioningInputs,
                        podId: formData.podId,
                    },
                    forceProvision: props.forceProvision,
                })
                    .then((response) => {
                    // Open a popup tab.
                    // If the popup is blocked, append userCode to query params of provision status page.
                    // The provision status page could show a button to FIT if userCode is in query params.
                    const userCode = response.userCode;
                    const isPopupBlocked = !window.open((0, functions_1.getDeviceVerificationUrl)(userCode));
                    const optionalUserCodeQuery = isPopupBlocked ? `?userCode=${userCode}` : '';
                    const userName = sessionStorage.getItem(CONSTANTS.SESSION_STORAGE_USERNAME);
                    props.setNotificationToPage([
                        {
                            header: localeBundle.getMessage('provision-input-saved'),
                            type: 'success',
                            action: ((0, jsx_runtime_1.jsx)(awsui_components_react_1.Button, { href: `${CONSTANTS.NAV_ROUTE_PROVISION}/${props.processId}/${props.nodeId}/${userName}/${props.deviceCode}${CONSTANTS.ROUTE_STATUS}${optionalUserCodeQuery}`, children: localeBundle.getMessage('view-provision-status') })),
                            content: ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)("pre", { children: [" ", localeBundle.getMessage('new-window-device-auth'), " "] }) })),
                            dismissible: true,
                            dismissLabel: 'Dismiss message',
                            onDismiss: () => props.setNotificationToPage([]),
                        },
                    ]);
                    setSubmitSucceed(true);
                    setFormErrors({});
                    setTimeout(function () {
                        window.location.replace(`${CONSTANTS.NAV_ROUTE_PROVISION}/${props.processId}/${props.nodeId}/${userName}/${props.deviceCode}${CONSTANTS.ROUTE_STATUS}${optionalUserCodeQuery}`);
                    }, 10000);
                })
                    .catch((error) => {
                    const errorHeader = error.response.status == 403 || error.response.status == 401
                        ? localeBundle.getMessage('unauthorized-user')
                        : localeBundle.getMessage('something-wrong');
                    let errorContent;
                    if (error.response != null && (error.response.status == 403 || error.response.status == 401)) {
                        errorContent = `${localeBundle.formatMessage((0, functions_1.getErrorMessageLocaleBundleKeyFromOperationName)(constants_1.EDM_API_TO_DEVICE_GROUP_OPERATION_MAP.get(constants_1.EDM_TRANSACTIONAL_SAVE_PROVISION_DETAILS_API_NAME)), {
                            wikiLink: CONSTANTS.AUTHZ_DOCUMENTATION_WIKI_LINK,
                        })} Error: ${error.response.data.message}`;
                    }
                    else if (error.response) {
                        errorContent = localeBundle.formatMessage('submit-provision-input-failure', {
                            errorMessage: error.response.data.message,
                        });
                    }
                    else {
                        errorContent = localeBundle.formatMessage('submit-provision-input-failure', {
                            errorMessage: error.message,
                        });
                    }
                    console.log(errorContent);
                    props.setNotificationToPage([
                        {
                            header: errorHeader,
                            type: 'error',
                            content: `${errorContent}`,
                            dismissible: true,
                            dismissLabel: 'Dismiss message',
                            onDismiss: () => props.setNotificationToPage([]),
                        },
                    ]);
                });
            }
            else {
                let errorContent = '';
                for (const [key, value] of Object.entries(formErrors)) {
                    errorContent += `${key}: ${value} \n`;
                }
                props.setNotificationToPage([
                    {
                        header: localeBundle.getMessage('invalid-input'),
                        type: 'error',
                        content: ((0, jsx_runtime_1.jsx)("div", { children: errorContent.split('\n').map((item, i) => ((0, jsx_runtime_1.jsx)("div", { children: item }, 'x' + i))) })),
                        dismissible: true,
                        dismissLabel: 'Dismiss message',
                        onDismiss: () => props.setNotificationToPage([]),
                    },
                ]);
                setFormErrors({});
            }
        }
    }, [isSubmit, formData, formErrors, localeBundleLoaded]);
    return ((0, jsx_runtime_1.jsxs)(awsui_components_react_1.SpaceBetween, { size: "l", children: [(0, jsx_runtime_1.jsx)(registered_information_1.RegisteredInformation, { isManagedEdgeCompute: props.isManagedEdgeCompute, processId: props.processId, nodeId: props.nodeId, deviceCode: props.deviceCode }), (0, jsx_runtime_1.jsx)(awsui_components_react_1.Container, { header: (0, jsx_runtime_1.jsx)(awsui_components_react_1.Header, { variant: "h2", actions: (0, jsx_runtime_1.jsx)(awsui_components_react_1.Button, { iconName: "refresh", variant: "normal", onClick: () => onRefreshClick(), children: localeBundle === undefined ? 'Clear' : localeBundle.getMessage('clear') }), description: localeBundle === undefined
                        ? 'Please consult process owner to confirm if default values work for your provision before submitting inputs'
                        : localeBundle.getMessage('provision-setting-description'), children: localeBundle === undefined
                        ? 'Provision settings'
                        : localeBundle.getMessage('provision-setting') }), children: (0, jsx_runtime_1.jsx)(awsui_components_react_1.Form, { actions: (0, jsx_runtime_1.jsx)(awsui_components_react_1.Button, { variant: "primary", onClick: (e) => onSubmitClick(e), disabled: submitSucceed, children: localeBundle === undefined ? 'Submit' : localeBundle.getMessage('submit') }), children: (0, jsx_runtime_1.jsx)(provision_input_form_1.default, { isManagedEdgeCompute: props.isManagedEdgeCompute, formData: formData, processId: process.selectedProcess, templateUrls: templateUrls, setFormData: setFormData, provisionInputTemplate: provisionInputTemplate, setProvisionInputTemplate: setProvisionInputTemplate, selectedPodId: selectedPodId, setSelectedPodId: setSelectedPodId }) }) })] }));
};
function ProvisionInputPage(props) {
    const [localeBundle] = (0, react_arb_tools_1.useBundle)(CONSTANTS.STRINGS_NAMESPACE);
    const query = (0, hooks_1.useQuery)();
    const forceProvision = query.get('forceProvision') === 'true';
    // For ManagedEdgeCompute provision, processId and nodeId from Params are undefined
    // They are not used in further steps if the page is for ManagedEdgeCompute provision
    const { processId, nodeId, deviceCode } = (0, react_router_dom_1.useParams)();
    const [notification, setNotification] = react_1.default.useState([]);
    const setNotificationToPage = (newNotification) => {
        setNotification(newNotification);
    };
    const process = (0, process_helpers_1.useProcess)();
    const selectedProcessId = process.selectedProcess;
    return ((0, jsx_runtime_1.jsx)(base_layout_1.BaseLayout, { breadcrumbs: 
        // TODO: Make Breadcurmbs point to the right place based on is managed edge compute device
        (0, jsx_runtime_1.jsx)(bread_crumbs_1.Breadcrumbs, { items: [
                {
                    text: localeBundle === undefined
                        ? 'Provision Input'
                        : localeBundle.getMessage('provision-input'),
                    href: CONSTANTS.NAV_ROUTE_PROVISION_REGISTERED_DEVICE,
                },
                {
                    text: deviceCode,
                    href: '#/provision/' + deviceCode + '/status',
                },
            ] }), content: (0, jsx_runtime_1.jsx)(Content, { isManagedEdgeCompute: props.isManagedEdgeCompute, 
            // TODO: For backward compatibility, Touch-less provision still uses processId read from param. Unify this in future
            processId: props.isManagedEdgeCompute ? selectedProcessId : processId, nodeId: nodeId, deviceCode: deviceCode, forceProvision: forceProvision, setNotificationToPage: setNotificationToPage }), notifications: (0, jsx_runtime_1.jsx)(notification_1.Notification, { items: notification }), contentType: "form" }));
}
exports.default = ProvisionInputPage;
